export default {
    data() {
        return {
            isOpenEditSnack: false,
            editSnackColor: '',
            editSnackText: '',
            editSnackTimeout: 3000,
        }
    },
    methods: {
        openEditSnack({ text, color }) {
            this.editSnackText = text;
            this.editSnackColor = color;
            this.isOpenEditSnack = true;

            setTimeout(() => {
                this.resetEditSnack();
            }, this.editSnackTimeout)
        },
        openInfoEditSnack(text = this.$t('edit')) {
            this.resetEditSnack();
            this.openEditSnack({ text, color: 'info' });
        },
        openErrorEditSnack(text = this.$t('changesSavedError')) {
            this.resetEditSnack();
            this.openEditSnack({ text, color: 'error' });
        },
        openSuccessEditSnack(text = this.$t('changesSaved')) {
            this.resetEditSnack();
            this.openEditSnack({ text, color: 'success' });
        },
        openSuccessRemoveSnack(text = this.$t('changesSaved')) {
            this.resetEditSnack();
            this.openEditSnack({ text:' Пользователь удален', color: 'success' });
        },
        resetEditSnack() {
            this.isOpenEditSnack = false;
            this.editSnackText = '';
            this.editSnackColor = '';
            this.editSnackTimeout = 3000;
        }
    },
}
